<template>
  <div>
    <template v-for="(blockItem, index) in contentList">
      <div :key="index">
        <template v-if="blockItem.type === 'text'">
          <div class="block-item block-item--text">
            <div v-html="blockItem.content"></div>
          </div>
        </template>

        <template v-if="blockItem.type === 'image'">
          <div class="block-item block-item--image">
            <template v-for="(srcItem, index) in blockItem.src">
              <img :src="srcItem" :key="srcItem + index"/>
              <div :key="srcItem" class="block-item__caption">
                <span>{{blockItem.caption}}</span>
              </div>
            </template>
          </div>
        </template>

        <template v-if="blockItem.type === 'link'">
          <div class="block-item block-item--link">
            <a :href="blockItem.href" target="_blank">
              <span>{{blockItem.title}}</span>
            </a>
          </div>
        </template>

        <template v-if="blockItem.type === 'video'">
          <div class="block-item block-item--video">
            <video-player
              class="vjs-mc-skin"
              :playsinline="true"
              :options="blockItem.playerOption"
              ref="videoPlayer">
            </video-player>
            <div class="block-item__caption">
              <span>{{blockItem.caption}}</span>
            </div>
          </div>
        </template>

        <template v-if="blockItem.type === 'qq-video'">
          <div class="block-item block-item--qq-video">
            <iframe frameborder="0"
              class="qq-video-iframe"
              :src= "blockItem.videoUrl"
              allowFullScreen="true">
            </iframe>
            <div class="block-item__caption">
              <span>{{blockItem.caption}}</span>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      contentList: [],
      playerOption: {
        height: '380',
        autoplay: false,
        muted: false,
        loop: false,
        language: 'zh-CN',
        playbackRates: [1.0, 1.5, 2.0],
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        sources: [{
          src: '',
        }],
      },
    };
  },
  props: {
    content: {
      type: Array,
      default: () => []
    },
  },
  watch: {
    content: {
      handler() {
        this.initData();
      },
      immediate: true,
    },
  },
  methods: {
    initData() {
      if (this.content) {
        this.contentList = this.content.map(item => {
          let contentItem = { ...item };
          if (contentItem.type === 'video') {
            const articleVideoPlayerOption = JSON.parse(JSON.stringify(this.playerOption));
            articleVideoPlayerOption.sources[0].src = item.src;
            contentItem.playerOption = articleVideoPlayerOption;
          }
          if (contentItem.type === 'image') {
            contentItem.src = [`${item.src}`];
          }
          if (contentItem.type === 'qq-video') {
            contentItem.videoUrl = `https://v.qq.com/txp/iframe/player.html?vid=${item.vid}`;
          }
          return contentItem;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.block-item {
  padding: 5px 0;
  word-break: break-word;
}
.block-item__caption {
  text-align: center;
  color: #999;
}
.block-item--image {
  text-align: center;
  img {
    max-width: 100%;
  }
}
.block-item--link {
  a {
    color: #0a84e1;
  }
}
.qq-video-iframe {
  width: 100%;
  height: 360px;
}
</style>
